import React from 'react';

import laptop from './images/laptop.png';
import '../App.css';

export default function Home() {
 

  return (
    <section id='home'>
    <div className="full-bg text-light d-flex flex-column">
      {/* Navbar */}
      {/* <nav className="navbar navbar-expand-md navbar-dark px-4 sticky-top custom-navbar">
        <a className="navbar-brand" href="#">
          <img src={logo} alt="Logo" width="80" height="40" />
        </a>


        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={`navbar-collapse justify-content-end ${isOpen ? 'show d-block' : 'collapse'}`}>
          <ul className="navbar-nav gap-4">
            <li className="nav-item"><a className="nav-link" href="#home" onClick={() => setIsOpen(false)}>Home</a></li>
            <li className="nav-item"><a className="nav-link" href="#about" onClick={() => setIsOpen(false)}>About</a></li>
            <li className="nav-item"><a className="nav-link" href="#features" onClick={() => setIsOpen(false)}>Features</a></li>
            <li className="nav-item"><a className="nav-link" href="#contact" onClick={() => setIsOpen(false)}>Contact</a></li>
          </ul>
        </div>

      </nav> */}

      {/* Title */}
      <div className="text-center mt-5">
        <h1 className="gradient-text">MDQ'S</h1>
        <h1 className="gradient-text">Production Management System</h1>
      </div>

      {/* Image */}
      <div className="container mt-auto text-center">
        <img src={laptop} className="img-fluid" alt="Laptop" />
      </div>
    </div>
   </section> 
  );
} 